import { render, staticRenderFns } from "./CentroCusto.vue?vue&type=template&id=62d78af7&lang=html&"
import script from "./CentroCusto.vue?vue&type=script&lang=js&"
export * from "./CentroCusto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/centro-custo/CentroCusto.vue
// module id = 1106
// module chunks = 28